import {CategoryId} from '../form/types';
import {EventType} from './EventType';

export enum CategoryVersion {
  V1_0 = 'V1_0', V1_5 = 'V1_5', V2_0 = 'V2_0'
}

export interface Category {
  id: CategoryId
  name: string
  version: CategoryVersion
  types: EventType[]
}
